import { ChainId } from '@ourzora/chains'

import { addresses } from '../../addresses'
import abi from './abi'

export const ZoraRewards = {
  abi,
  latest: (chainId: ChainId) => ZoraRewards.deployments(chainId).at(-1),
  deployments: (chainId: ChainId) => addresses.ZORA_REWARDS[chainId],
} as const
